import type { PayloadAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';
import {
  fetchCustomerContactsFailure,
  fetchCustomerContactsRequest,
  fetchCustomerContactsSuccess,
  upsertCustomerContactsFailure,
  upsertCustomerContactsRequest,
  upsertCustomerContactsuccess,
} from 'actions/customerContacts';

import { CustomerContactInformation, ErrorObject } from 'types';

type CustomerContactsState = {
  customerContacts: CustomerContactInformation | null;
  loading: string[];
  error: ErrorObject | null;
};

const defaultState: CustomerContactsState = {
  customerContacts: null,
  loading: [],
  error: null,
};

type CustomerContactsReducer<P = void> = (
  state: CustomerContactsState,
  payload: PayloadAction<P>
) => CustomerContactsState | void;

const handleFetchCustomerContactsRequest: CustomerContactsReducer = (state) => {
  state.loading = [...state.loading, fetchCustomerContactsRequest.toString()];
};

const handleFetchCustomerContactsFailure: CustomerContactsReducer<ErrorObject> = (
  state,
  { payload }
) => {
  state.loading = state.loading.filter((l) => l !== fetchCustomerContactsRequest.toString());
  state.error = payload;
};

const handleFetchCustomerContactsSuccess: CustomerContactsReducer<CustomerContactInformation> = (
  state,
  { payload }
) => {
  state.loading = state.loading.filter((l) => l !== fetchCustomerContactsRequest.toString());
  if (payload) {
    state.customerContacts = payload;
  } else {
    state.customerContacts = defaultState.customerContacts;
  }
};

const handleUpsertCustomerContactsRequest: CustomerContactsReducer = (state) => {
  state.loading = [...state.loading, upsertCustomerContactsRequest.toString()];
};

const handleUpsertCustomerContactsFailure: CustomerContactsReducer<ErrorObject> = (
  state,
  { payload }
) => {
  state.loading = state.loading.filter((l) => l !== upsertCustomerContactsRequest.toString());
  state.error = payload;
};

const handleUpsertCustomerContactsSuccess: CustomerContactsReducer<CustomerContactInformation> = (
  state,
  { payload }
) => {
  state.loading = state.loading.filter((l) => l !== upsertCustomerContactsRequest.toString());
  state.customerContacts = payload;
};

const handlers = {
  [fetchCustomerContactsRequest.toString()]: handleFetchCustomerContactsRequest,
  [fetchCustomerContactsFailure.toString()]: handleFetchCustomerContactsFailure,
  [fetchCustomerContactsSuccess.toString()]: handleFetchCustomerContactsSuccess,

  [upsertCustomerContactsRequest.toString()]: handleUpsertCustomerContactsRequest,
  [upsertCustomerContactsFailure.toString()]: handleUpsertCustomerContactsFailure,
  [upsertCustomerContactsuccess.toString()]: handleUpsertCustomerContactsSuccess,
};

const CustomerContactsReducer = createReducer(defaultState, handlers);

export default CustomerContactsReducer;
